import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.80169,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const EnvelopeIcon = createSvgIcon(
  <>
    <path
      d="M0.900963 2.56181C0.900963 2.1213 1.07595 1.69884 1.38744 1.38735C1.69892 1.07587 2.12138 0.900879 2.56189 0.900879H14.1884C14.6289 0.900879 15.0513 1.07587 15.3628 1.38735C15.6743 1.69884 15.8493 2.1213 15.8493 2.56181V10.8664C15.8493 11.3069 15.6743 11.7294 15.3628 12.0409C15.0513 12.3524 14.6289 12.5274 14.1884 12.5274H2.56189C2.12138 12.5274 1.69892 12.3524 1.38744 12.0409C1.07595 11.7294 0.900963 11.3069 0.900963 10.8664V2.56181Z"
      {...strokeProps}
    />
    <path
      d="M0.90094 2.56189L8.37511 7.54467L15.8493 2.56189"
      {...strokeProps}
    />
  </>,
  { displayName: 'EnvelopeIcon', viewBox: '0 0 17 14' }
);
